// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YGDl","type":"styles_type__209EU","choices":"styles_choices__2i2hW"};